"use strict";
export var OnchainItemListOptionType = /* @__PURE__ */ ((OnchainItemListOptionType2) => {
  OnchainItemListOptionType2["Token"] = "Token";
  OnchainItemListOptionType2["Pool"] = "Pool";
  OnchainItemListOptionType2["WalletByAddress"] = "WalletByAddress";
  OnchainItemListOptionType2["ENSAddress"] = "ENSAddress";
  OnchainItemListOptionType2["Unitag"] = "Unitag";
  OnchainItemListOptionType2["NFTCollection"] = "NFTCollection";
  return OnchainItemListOptionType2;
})(OnchainItemListOptionType || {});
